import(/* webpackMode: "eager" */ "/vercel/path0/src/app/qonnect/page.js");
